// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"3ce5b659","579":"8a6c8c6d","683":"2b1c6d01","965":"7879b642","988":"c03aeac5"}[chunkId] + ".css";
};